import React, { useState, useRef } from 'react';
import { Link } from "react-router-dom";
import { NavigationSection } from '../types/NavigationSection';
import animeMyself from '../assets/animeMyself.png';
import Typing from "./Typing";
import TypingOnce from "./TypingOnlyOnce";
import cert_316 from '../assets/316_cert.png';
import cert_331 from '../assets/331_cert.png';
import FadeInImages from './FadeInImages';
import TypingVoc from "../assets/keyboardTypingVoc.mp3";

const About: React.FC = () => {
    const [startTyping, setStartTyping] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);

    const handleStart = () => {
        if (!startTyping) {
            const audio = new Audio(TypingVoc);
            audio.volume = 0.2;
            audioRef.current = audio;
            audio.play().catch(err => console.log("Playback blocked:", err));
            setStartTyping(true);
        }
    };
    return (
        <section 
            id={NavigationSection.ABOUT} 
            className="items-start justify-start min-h-80 flex flex-row selection:bg-fuchsia-900 text-grey-200">
            <Link to="/">
            <img 
                src={animeMyself}
                alt="A personal anime version profile selfie and clickable to return"
                className="h-auto max-w-40 mb-4"
                onClick={() => {
                    if (audioRef.current) {
                        audioRef.current.pause();
                        audioRef.current.currentTime = 0; 
                        audioRef.current = null;
                    }
                }}
            />
            </Link>
            <div className="justify-center items-center min-h-80 mt-20 ">
                <h2 className="font-pixel text-4xl font-bold mb-4">About me</h2>
                
                {/* Mobile Design below */}
                <div className="lg:hidden">
                    <h2 className="font-pixel text-black text-3xl font-bold">
                        [<Typing text="...Coder" />]
                    </h2>
                    <br />
                    <h2 className="font-pixel text-black text-2xl font-bold">
                        I graduated from University of Auckland in 2026 and got A+ in both Compsci 331 - [Large-Scale Software Development] and Compsci 316 - [Cyber Security].
                    </h2>
                </div>

                {/* Desktop Design below */}

                <br/>
                <div className="hidden lg:block">
                    {!startTyping ? (
                        <h2
                            className="font-pixel text-black text-4xl font-bold mb-4"
                            onClick={handleStart}
                        >
                            [ Click to reveal my role]
                        </h2> ) : (
                        <h2 className="font-pixel text-black text-4xl font-bold mb-4"> 
                            [<Typing text="...Coder" />]
                        </h2>
                    )}
                    <br/>
                    {!startTyping ? (
                        <p className="font-sans text-center text-lg mb-4">
                            
                        </p>    ) : (
                            <p className="font-sans text-center text-lg mb-4">
                                <TypingOnce text="I  graduated from University of Auckland in 2026 and 
                                got A+ in both Compsci 331 - [Large-Scale Software Development] 
                                and Compsci 316 - [Cyber Security]."/>
                            </p>
                    )}
                    
                    <FadeInImages isTypingDone={startTyping}>
                            <img 
                                src={cert_331}
                                alt="Compsci 331 A+ certificate"
                                className="h-auto max-w-80 mb-4"
                            />

                            <img 
                                src={cert_316}
                                alt="Compsci 316 A+ certificate"
                                className="h-auto max-w-80 mb-4"
                            />
                    </FadeInImages>
                </div>
            </div>

        </section>
    );
};

export default About;